import { actionTypes } from "../constants/action-types";
import moment from "moment";
import { colors, graphColors } from "../../helpers/meta";

const tempSeries = (
  series = [],
  color = colors.primary,
  title = "",
  type = "line",
  smooth = false
) => {
  // const grays = getGrays(false);
  return {
    title: "Title_" + title,
    label: "Label_" + title,
    name: title,
    type: type,
    color: color,
    data: series,
    lineStyle: { color: color, width: 4 },
    symbol: "circle",
    symbolSize: 5,
    smooth: smooth,
    hoverAnimation: true,
    barMaxWidth: 20,
  };
};

const getLabels = (startDate, endDate) => {
  var labels = [];
  var start = moment(startDate);
  var end = moment(endDate);
  if (end.diff(start, "day") <= 1) {
    while (end.diff(start, "hour") > 0) {
      labels.push(start.format("hh:mm a"));
      start = start.add(1, "hour");
    }
  } else {
    while (end.diff(start, "day") >= 0) {
      labels.push(start.format("MMM D"));
      start = start.add(1, "day");
    }
  }
  return labels;

};

const compileData = (startDate, endDate, rawdata, entity, title, ind, type = "line") => {
  var data = [];
  var index = 0;
  let start = moment(startDate);
  let end = moment(endDate);
  if (end.diff(start, "day") < 1) {
    rawdata = rawdata.sort((a, b) => {
      return a._id - b._id;
    });
    while (end.diff(start, "hour") > 0) {
      if (rawdata.length && index < rawdata.length) {
        if (start.format("HH") === rawdata[index]._id) {
          data.push(rawdata[index][entity]);
          index++;
        } else {
          data.push(0);
        }
      } else {
        data.push(0);
      }
      start = start.add(1, "hour");
    }
  } else {
    rawdata = rawdata.sort((a, b) => {
      return new Date(a._id) - new Date(b._id);
    });
    while (end.diff(start, "day") >= 0) {
      if (rawdata.length && index < rawdata.length) {
        if (start.format("YYYY-MM-DD") === rawdata[index]._id) {
          data.push(rawdata[index][entity]);
          index++;
        } else {
          data.push(0);
        }
      } else {
        data.push(0);
      }
      start = start.add(1, "day");
    }
  }
  return tempSeries(
    data, graphColors[ind], title, type
  );
};

const initialState = {
  all_data: null,
  startDate : moment(new Date()).startOf("day"),
  endDate: moment(new Date()).endOf("day"),
  labels : [],
  grapGhRawData : [],
  data: {
    total: 0,
    footfall: [
      {  },
    ],
  },
  graphs: [],
  type: "line",
  filter: {
    type: "today",
    store: null,
    stores: [],
    floor: null,
    floors: [],
    start: moment(new Date()).startOf("day"),
    end: moment(new Date()).endOf("day"),
  },
  loader: false,
};

export const footfallReducer = (
  state = initialState,
  { type, payload = {} }
) => {
  switch (type) {
    case actionTypes.SET_FOOTFALL:
      var data = JSON.parse(JSON.stringify(initialState.data));
      {
        var obj = payload[0];
      }
      return { ...state, data: data, all_data: obj };
    case actionTypes.SET_FOOTFALL_GRAPH:
      return {...state, grapGhRawData: payload}
    case actionTypes.SET_FOOTFALL_GRAPH_TYPE:
      var graphs = state.graphs;
      Object.keys(graphs).forEach(key => {
        graphs[key].data.forEach((row) => {
          row.type = payload;
        })
      });
      return {...state, type: payload, graphs: graphs}
    case actionTypes.SET_FOOTFALL_FILTER:
      localStorage.setItem("filter", JSON.stringify(payload));
      var labels = getLabels({startDate : payload.start,endDate : payload.end});
      return { ...state, startDate: payload._startDate, endDate :payload._endDate, labels : labels };

      case actionTypes.SET_FOOTFALL_LOADER:
      return { ...state, loader: payload };
      case actionTypes.SET_GRAPGH_DATA :
        let _type = state.type;
        let grapghPayload = payload.grapghRawData.map((val) => {
          let mask = Math.floor(val.total * 0.92);
          return {
            ...val,
            mask: mask,
            noMask: val.total - mask,
            adult: val.total - val.kid,
            dwelltime: Math.floor(300 + 150 * Math.random()),
          };
        });
  
        let graphDataa = {};
        payload.footfall.forEach((item, index) => {
          graphDataa[item.key] = {
            data: item.children.map((val, ind) => {
              return compileData(
                payload?.startDate,
                payload?.endDate,
                grapghPayload,
                val.key,
                val.label,
                ind,
                _type
              );
            }),
          };
        });
  
        return { ...state, graphs: graphDataa };

    default:
      return state;
  }
};
